export default {
  height: 19,
  width: 20,
  stroke: true,
  svg: `
  <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M13.8105 1.00004c-.7947-.003156-1.5773.19391-2.2757.57301-.6984.37909-1.29.92801-1.72029 1.59607-.43028-.66806-1.02192-1.21698-1.72031-1.59607-.69839-.3791-1.48101-.576166-2.27565-.57301-.63641.00122-1.2663.12825-1.85344.37377-.58714.24553-1.11996.6047-1.5678 1.05687-.44784.45217-.80187.98841-1.04173 1.57789-.23986.58948-.360823 1.22056-.355925 1.85695 0 4.83618 8.814855 12.13458 8.814855 12.13458s8.81489-7.2984 8.81489-12.13458c.0049-.63639-.1161-1.26747-.356-1.85695-.2398-.58948-.5938-1.12572-1.0417-1.57789-.4478-.45217-.9806-.81134-1.5678-1.05687-.5871-.24552-1.217-.37255-1.8534-.37377z"/>
`
}
